export const returnFocusToPageTitle = (id: string) => {
  const titleElement = document.getElementById(id);
  titleElement?.focus();
};
